export default "__VITE_ASSET__CJ4YMAwz__"